module.exports = __webpack_public_path__ + "static/media/service-img04.e68c7312.png";